import {IController} from "../../../controllers/IController";
import {InjectionToken} from "@angular/core";
import {ModelKey} from "../../../models/ModelKey";
import {UserAvatarInputConfigModel} from "../_models/UserAvatarInputConfigModel";

export const IT_USER_AVATAR_CONTROLLER = new InjectionToken<IUserAvatarController>('IT_USER_AVATAR_CONTROLLER');
export const MK_USER_AVATAR_INPUT_CONFIG = new ModelKey<UserAvatarInputConfigModel>('MK_USER_AVATAR_INPUT_CONFIG');


export interface IUserAvatarController extends IController {

  handleConfigOverwrite(eventData: any): void;
}
